import { render, staticRenderFns } from "./AssignmentCourierGroup.vue?vue&type=template&id=d2d72790&scoped=true&"
import script from "./AssignmentCourierGroup.vue?vue&type=script&lang=js&"
export * from "./AssignmentCourierGroup.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentCourierGroup.vue?vue&type=style&index=0&id=d2d72790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d72790",
  null
  
)

export default component.exports